// extracted by mini-css-extract-plugin
module.exports = {"title":"_3_b7JK","list":"_1fK6Uf","itemPlaceholder":"_3wajKZ","shine-lines":"_1ooYOO","controls":"_3SZQvE"};